import script from "./MaterialsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialsModal.vue?vue&type=script&setup=true&lang=js"

import "./MaterialsModal.vue?vue&type=style&index=0&id=53dbf9df&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53dbf9df"]])

export default __exports__